import type { ReactNode } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

export function ConfirmDialog({
  title,
  description,
  details,
  confirmLabel,
  isPending,
  error,
  onConfirm,
  onCancel,
}: {
  title: string;
  description: string;
  /** What the action drags along with it, when that is not obvious. */
  details?: ReactNode;
  confirmLabel: string;
  isPending?: boolean;
  /** A failed mutation stays in the dialog so the user can act on it. */
  error?: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <Dialog open onOpenChange={(isOpen) => !isOpen && !isPending && onCancel()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>

        {details ? (
          <div className="rounded-lg border border-warning/30 bg-warning-soft px-4 py-3 text-sm text-warning-foreground">
            {details}
          </div>
        ) : null}

        {error ? (
          <div
            role="alert"
            className="rounded-lg border border-destructive/30 bg-destructive-soft px-4 py-3 text-sm text-destructive"
          >
            {error}
          </div>
        ) : null}

        <DialogFooter className="gap-3 sm:gap-2">
          <Button type="button" variant="outline" size="lg" onClick={onCancel} disabled={isPending}>
            Annuler
          </Button>
          <Button type="button" variant="destructive" size="lg" onClick={onConfirm} disabled={isPending}>
            {isPending ? "Suppression…" : error ? "Réessayer" : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
